export default __webpack_public_path__ + "static/media/B185.095c9321.png";